/**
 * @license
 * Copyright 2025 Kai-Orion & Sandlada
 * SPDX-License-Identifier: MIT
 */
import { Shape, State } from '@sandlada/mdk'
import { Color } from '../utils/tokens/theme'
import { createStyleDefinition } from '../utils/tokens/create-style-definition'

const sharedShapes = {
    'extra-small-container-shape-round-start-start': Shape.Full,
    'extra-small-container-shape-round-start-end': Shape.Full,
    'extra-small-container-shape-round-end-start': Shape.Full,
    'extra-small-container-shape-round-end-end': Shape.Full,
    'extra-small-container-shape-square-start-start': Shape.Medium,
    'extra-small-container-shape-square-start-end': Shape.Medium,
    'extra-small-container-shape-square-end-start': Shape.Medium,
    'extra-small-container-shape-square-end-end': Shape.Medium,
    'extra-small-container-shape-pressed-morph-start-start': Shape.Small,
    'extra-small-container-shape-pressed-morph-start-end': Shape.Small,
    'extra-small-container-shape-pressed-morph-end-start': Shape.Small,
    'extra-small-container-shape-pressed-morph-end-end': Shape.Small,
    'extra-small-container-shape-round-selected-start-start': Shape.Medium,
    'extra-small-container-shape-round-selected-start-end': Shape.Medium,
    'extra-small-container-shape-round-selected-end-start': Shape.Medium,
    'extra-small-container-shape-round-selected-end-end': Shape.Medium,
    'extra-small-container-shape-square-selected-start-start': Shape.Full,
    'extra-small-container-shape-square-selected-start-end': Shape.Full,
    'extra-small-container-shape-square-selected-end-start': Shape.Full,
    'extra-small-container-shape-square-selected-end-end': Shape.Full,

    'small-container-shape-round-start-start': Shape.Full,
    'small-container-shape-round-start-end': Shape.Full,
    'small-container-shape-round-end-start': Shape.Full,
    'small-container-shape-round-end-end': Shape.Full,
    'small-container-shape-square-start-start': Shape.Medium,
    'small-container-shape-square-start-end': Shape.Medium,
    'small-container-shape-square-end-start': Shape.Medium,
    'small-container-shape-square-end-end': Shape.Medium,
    'small-container-shape-pressed-morph-start-start': Shape.Small,
    'small-container-shape-pressed-morph-start-end': Shape.Small,
    'small-container-shape-pressed-morph-end-start': Shape.Small,
    'small-container-shape-pressed-morph-end-end': Shape.Small,
    'small-container-shape-round-selected-start-start': Shape.Medium,
    'small-container-shape-round-selected-start-end': Shape.Medium,
    'small-container-shape-round-selected-end-start': Shape.Medium,
    'small-container-shape-round-selected-end-end': Shape.Medium,
    'small-container-shape-square-selected-start-start': Shape.Full,
    'small-container-shape-square-selected-start-end': Shape.Full,
    'small-container-shape-square-selected-end-start': Shape.Full,
    'small-container-shape-square-selected-end-end': Shape.Full,

    'medium-container-shape-round-start-start': Shape.Full,
    'medium-container-shape-round-start-end': Shape.Full,
    'medium-container-shape-round-end-start': Shape.Full,
    'medium-container-shape-round-end-end': Shape.Full,
    'medium-container-shape-square-start-start': Shape.Large,
    'medium-container-shape-square-start-end': Shape.Large,
    'medium-container-shape-square-end-start': Shape.Large,
    'medium-container-shape-square-end-end': Shape.Large,
    'medium-container-shape-pressed-morph-start-start': Shape.Medium,
    'medium-container-shape-pressed-morph-start-end': Shape.Medium,
    'medium-container-shape-pressed-morph-end-start': Shape.Medium,
    'medium-container-shape-pressed-morph-end-end': Shape.Medium,
    'medium-container-shape-round-selected-start-start': Shape.Large,
    'medium-container-shape-round-selected-start-end': Shape.Large,
    'medium-container-shape-round-selected-end-start': Shape.Large,
    'medium-container-shape-round-selected-end-end': Shape.Large,
    'medium-container-shape-square-selected-start-start': Shape.Full,
    'medium-container-shape-square-selected-start-end': Shape.Full,
    'medium-container-shape-square-selected-end-start': Shape.Full,
    'medium-container-shape-square-selected-end-end': Shape.Full,

    'large-container-shape-round-start-start': Shape.Full,
    'large-container-shape-round-start-end': Shape.Full,
    'large-container-shape-round-end-start': Shape.Full,
    'large-container-shape-round-end-end': Shape.Full,
    'large-container-shape-square-start-start': Shape.ExtraLarge,
    'large-container-shape-square-start-end': Shape.ExtraLarge,
    'large-container-shape-square-end-start': Shape.ExtraLarge,
    'large-container-shape-square-end-end': Shape.ExtraLarge,
    'large-container-shape-pressed-morph-start-start': Shape.Large,
    'large-container-shape-pressed-morph-start-end': Shape.Large,
    'large-container-shape-pressed-morph-end-start': Shape.Large,
    'large-container-shape-pressed-morph-end-end': Shape.Large,
    'large-container-shape-round-selected-start-start': Shape.ExtraLarge,
    'large-container-shape-round-selected-start-end': Shape.ExtraLarge,
    'large-container-shape-round-selected-end-start': Shape.ExtraLarge,
    'large-container-shape-round-selected-end-end': Shape.ExtraLarge,
    'large-container-shape-square-selected-start-start': Shape.Full,
    'large-container-shape-square-selected-start-end': Shape.Full,
    'large-container-shape-square-selected-end-start': Shape.Full,
    'large-container-shape-square-selected-end-end': Shape.Full,

    'extra-large-container-shape-round-start-start': Shape.Full,
    'extra-large-container-shape-round-start-end': Shape.Full,
    'extra-large-container-shape-round-end-start': Shape.Full,
    'extra-large-container-shape-round-end-end': Shape.Full,
    'extra-large-container-shape-square-start-start': Shape.ExtraLarge,
    'extra-large-container-shape-square-start-end': Shape.ExtraLarge,
    'extra-large-container-shape-square-end-start': Shape.ExtraLarge,
    'extra-large-container-shape-square-end-end': Shape.ExtraLarge,
    'extra-large-container-shape-pressed-morph-start-start': Shape.Large,
    'extra-large-container-shape-pressed-morph-start-end': Shape.Large,
    'extra-large-container-shape-pressed-morph-end-start': Shape.Large,
    'extra-large-container-shape-pressed-morph-end-end': Shape.Large,
    'extra-large-container-shape-round-selected-start-start': Shape.ExtraLarge,
    'extra-large-container-shape-round-selected-start-end': Shape.ExtraLarge,
    'extra-large-container-shape-round-selected-end-start': Shape.ExtraLarge,
    'extra-large-container-shape-round-selected-end-end': Shape.ExtraLarge,
    'extra-large-container-shape-square-selected-start-start': Shape.Full,
    'extra-large-container-shape-square-selected-start-end': Shape.Full,
    'extra-large-container-shape-square-selected-end-start': Shape.Full,
    'extra-large-container-shape-square-selected-end-end': Shape.Full,
} as const

const shared = {
    'extra-small-container-height'      : `32px`,
    'extra-small-icon-size'             : `20px`,
    'extra-small-narrow-leading-space'  : `4px`,
    'extra-small-narrow-trailing-space' : `4px`,
    'extra-small-default-leading-space' : `6px`,
    'extra-small-default-trailing-space': `6px`,
    'extra-small-wide-leading-space'    : `10px`,
    'extra-small-wide-trailing-space'   : `10px`,
    'extra-small-outline-width'         : `1px`,

    'small-container-height'      : `40px`,
    'small-icon-size'             : `24px`,
    'small-narrow-leading-space'  : `4px`,
    'small-narrow-trailing-space' : `4px`,
    'small-default-leading-space' : `8px`,
    'small-default-trailing-space': `8px`,
    'small-wide-leading-space'    : `14px`,
    'small-wide-trailing-space'   : `14px`,
    'small-outline-width'         : `1px`,

    'medium-container-height'      : `56px`,
    'medium-icon-size'             : `24px`,
    'medium-narrow-leading-space'  : `12px`,
    'medium-narrow-trailing-space' : `12px`,
    'medium-default-leading-space' : `16px`,
    'medium-default-trailing-space': `16px`,
    'medium-wide-leading-space'    : `24px`,
    'medium-wide-trailing-space'   : `24px`,
    'medium-outline-width'         : `1px`,

    'large-container-height'      : `96px`,
    'large-icon-size'             : `32px`,
    'large-narrow-leading-space'  : `16px`,
    'large-narrow-trailing-space' : `16px`,
    'large-default-leading-space' : `32px`,
    'large-default-trailing-space': `32px`,
    'large-wide-leading-space'    : `48px`,
    'large-wide-trailing-space'   : `48px`,
    'large-outline-width'         : `2px`,

    'extra-large-container-height'      : `136px`,
    'extra-large-icon-size'             : `40px`,
    'extra-large-narrow-leading-space'  : `32px`,
    'extra-large-narrow-trailing-space' : `32px`,
    'extra-large-default-leading-space' : `48px`,
    'extra-large-default-trailing-space': `48px`,
    'extra-large-wide-leading-space'    : `72px`,
    'extra-large-wide-trailing-space'   : `72px`,
    'extra-large-outline-width'         : `3px`,
} as const

export const OutlinedIconButtonDefinition = createStyleDefinition({
    ...shared,
    ...sharedShapes,

    // Enabled
    'enabled-outline-color'                    : Color.OutlineVariant,
    'enabled-outline-color-toggle-unselected'  : Color.OutlineVariant,
    'enabled-outline-color-toggle-selected'    : `transparent`,
    'enabled-container-color'                  : `transparent`,
    'enabled-container-color-toggle-unselected': `transparent`,
    'enabled-container-color-toggle-selected'  : Color.InverseSurface,
    'enabled-icon-color'                       : Color.OnSurfaceVariant,
    'enabled-icon-color-toggle-unselected'     : Color.OnSurfaceVariant,
    'enabled-icon-color-toggle-selected'       : Color.InverseOnSurface,
    // Disabled
    'disabled-outline-color'                      : Color.OutlineVariant,
    'disabled-outline-color-toggle-unselected'    : Color.OutlineVariant,
    'disabled-outline-color-toggle-selected'      : `transparent`,
    'disabled-container-color'                    : `transparent`,
    'disabled-container-color-toggle-unselected'  : `transparent`,
    'disabled-container-color-toggle-selected'    : Color.OnSurface,
    'disabled-container-opacity'                  : `0.1`,
    'disabled-container-opacity-toggle-unselected': `0.1`,
    'disabled-container-opacity-toggle-selected'  : `0.1`,
    'disabled-icon-color'                         : Color.OnSurface,
    'disabled-icon-opacity'                       : `0.38`,
    // Hovered
    'hovered-state-layer-color'                  : Color.OnSurfaceVariant,
    'hovered-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'hovered-state-layer-color-toggle-selected'  : Color.InverseOnSurface,
    'hovered-state-layer-opacity'                : State.HoveredStateLayerOpacity,
    'hovered-icon-color'                         : Color.OnSurfaceVariant,
    'hovered-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'hovered-icon-color-toggle-selected'         : Color.InverseOnSurface,
    // Focused
    'focused-state-layer-color'                  : Color.OnSurfaceVariant,
    'focused-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'focused-state-layer-color-toggle-selected'  : Color.InverseOnSurface,
    'focused-state-layer-opacity'                : State.FocusedStateLayerOpacity,
    'focused-icon-color'                         : Color.OnSurfaceVariant,
    'focused-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'focused-icon-color-toggle-selected'         : Color.InverseOnSurface,
    // Pressed
    'pressed-state-layer-color'                  : Color.OnSurfaceVariant,
    'pressed-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'pressed-state-layer-color-toggle-selected'  : Color.InverseOnSurface,
    'pressed-state-layer-opacity'                : State.PressedStateLayerOpacity,
    'pressed-icon-color'                         : Color.OnSurfaceVariant,
    'pressed-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'pressed-icon-color-toggle-selected'         : Color.InverseOnSurface,
})

export const StandardIconButtonDefinition = createStyleDefinition({
    ...shared,
    ...sharedShapes,

    // Enabled
    'enabled-icon-color'                  : Color.OnSurfaceVariant,
    'enabled-icon-color-toggle-unselected': Color.OnSurfaceVariant,
    'enabled-icon-color-toggle-selected'  : Color.Primary,
    // Disabled
    'disabled-icon-color'  : Color.OnSurface,
    'disabled-icon-opacity': `0.38`,
    // Hovered
    'hovered-state-layer-color'                  : Color.OnSurfaceVariant,
    'hovered-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'hovered-state-layer-color-toggle-selected'  : Color.Primary,
    'hovered-state-layer-opacity'                : State.HoveredStateLayerOpacity,
    'hovered-icon-color'                         : Color.OnSurfaceVariant,
    'hovered-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'hovered-icon-color-toggle-selected'         : Color.Primary,
    // Focused
    'focused-state-layer-color'                  : Color.OnSurfaceVariant,
    'focused-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'focused-state-layer-color-toggle-selected'  : Color.Primary,
    'focused-state-layer-opacity'                : State.FocusedStateLayerOpacity,
    'focused-icon-color'                         : Color.OnSurfaceVariant,
    'focused-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'focused-icon-color-toggle-selected'         : Color.Primary,
    // Pressed
    'pressed-state-layer-color'                  : Color.OnSurfaceVariant,
    'pressed-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'pressed-state-layer-color-toggle-selected'  : Color.Primary,
    'pressed-state-layer-opacity'                : State.PressedStateLayerOpacity,
    'pressed-icon-color'                         : Color.OnSurfaceVariant,
    'pressed-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'pressed-icon-color-toggle-selected'         : Color.Primary,
})

export const FilledIconButtonDefinition = createStyleDefinition({
    ...shared,
    ...sharedShapes,

    // Enabled
    'enabled-container-color'                  : Color.Primary,
    'enabled-container-color-toggle-unselected': Color.SurfaceContainer,
    'enabled-container-color-toggle-selected'  : Color.Primary,
    'enabled-icon-color'                       : Color.OnPrimary,
    'enabled-icon-color-toggle-unselected'     : Color.OnSurfaceVariant,
    'enabled-icon-color-toggle-selected'       : Color.OnPrimary,
    // Disabled
    'disabled-container-color'  : Color.OnSurface,
    'disabled-container-opacity': `0.1`,
    'disabled-icon-color'       : Color.OnSurface,
    'disabled-icon-opacity'     : `0.38`,
    // Hovered
    'hovered-state-layer-color'                  : Color.OnPrimary,
    'hovered-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'hovered-state-layer-color-toggle-selected'  : Color.OnPrimary,
    'hovered-state-layer-opacity'                : State.HoveredStateLayerOpacity,
    'hovered-icon-color'                         : Color.OnPrimary,
    'hovered-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'hovered-icon-color-toggle-selected'         : Color.OnPrimary,
    // Focused
    'focused-state-layer-color'                  : Color.OnPrimary,
    'focused-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'focused-state-layer-color-toggle-selected'  : Color.OnPrimary,
    'focused-state-layer-opacity'                : State.FocusedStateLayerOpacity,
    'focused-icon-color'                         : Color.OnPrimary,
    'focused-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'focused-icon-color-toggle-selected'         : Color.OnPrimary,
    // Pressed
    'pressed-state-layer-color'                  : Color.OnPrimary,
    'pressed-state-layer-color-toggle-unselected': Color.OnSurfaceVariant,
    'pressed-state-layer-color-toggle-selected'  : Color.OnPrimary,
    'pressed-state-layer-opacity'                : State.PressedStateLayerOpacity,
    'pressed-icon-color'                         : Color.OnPrimary,
    'pressed-icon-color-toggle-unselected'       : Color.OnSurfaceVariant,
    'pressed-icon-color-toggle-selected'         : Color.OnPrimary,
})

export const FilledTonalIconButtonDefinition = createStyleDefinition({
    ...shared,
    ...sharedShapes,

    // Enabled
    'enabled-container-color'                  : Color.SecondaryContainer,
    'enabled-container-color-toggle-unselected': Color.SecondaryContainer,
    'enabled-container-color-toggle-selected'  : Color.Secondary,
    'enabled-icon-color'                       : Color.OnSecondaryContainer,
    'enabled-icon-color-toggle-unselected'     : Color.OnSecondaryContainer,
    'enabled-icon-color-toggle-selected'       : Color.OnSecondary,
    // Disabled
    'disabled-container-color'  : Color.OnSurface,
    'disabled-container-opacity': `0.1`,
    'disabled-icon-color'       : Color.OnSurface,
    'disabled-icon-opacity'     : `0.38`,
    // Hovered
    'hovered-state-layer-color'                  : Color.OnSecondaryContainer,
    'hovered-state-layer-color-toggle-unselected': Color.OnSecondaryContainer,
    'hovered-state-layer-color-toggle-selected'  : Color.OnSecondary,
    'hovered-state-layer-opacity'                : State.HoveredStateLayerOpacity,
    'hovered-icon-color'                         : Color.OnSecondaryContainer,
    'hovered-icon-color-toggle-unselected'       : Color.OnSecondaryContainer,
    'hovered-icon-color-toggle-selected'         : Color.OnSecondary,
    // Focused
    'focused-state-layer-color'                  : Color.OnSecondaryContainer,
    'focused-state-layer-color-toggle-unselected': Color.OnSecondaryContainer,
    'focused-state-layer-color-toggle-selected'  : Color.OnSecondary,
    'focused-state-layer-opacity'                : State.FocusedStateLayerOpacity,
    'focused-icon-color'                         : Color.OnSecondaryContainer,
    'focused-icon-color-toggle-unselected'       : Color.OnSecondaryContainer,
    'focused-icon-color-toggle-selected'         : Color.OnSecondary,
    // Pressed
    'pressed-state-layer-color'                  : Color.OnSecondaryContainer,
    'pressed-state-layer-color-toggle-unselected': Color.OnSecondaryContainer,
    'pressed-state-layer-color-toggle-selected'  : Color.OnSecondary,
    'pressed-state-layer-opacity'                : State.PressedStateLayerOpacity,
    'pressed-icon-color'                         : Color.OnSecondaryContainer,
    'pressed-icon-color-toggle-unselected'       : Color.OnSecondaryContainer,
    'pressed-icon-color-toggle-selected'         : Color.OnSecondary,
})
